module.exports = __webpack_public_path__ + "img/photo-0052.53740dfa.jpg";